import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import Projects from "./components/sections/Projects";
import BrandStrip from "./components/sections/BrandStrip";
import Contact from "./components/sections/Contact";
import Pricing from "./components/sections/Pricing";
import Testimonials from "./components/sections/Testimonials";
import CTA from "./components/sections/CTA";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/common/ScrollToTop";
import ClientsMarquee from "./components/sections/ClientsMarquee";

export default function App() {
  return (
    <>
      <Navbar />

      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <BrandStrip />
        <Contact />
        {/* <Team /> */}
        <Pricing />
        <ClientsMarquee />
        <Testimonials />
        <CTA />
        {/* <Blog /> */}
      </main>

      <ScrollToTop />

      <Footer />

      <ToastContainer
        position="top-right"
        autoClose={2400}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
    </>
  );
}
